import { featuredNews, newsList } from '@/mocks/wuyi';
import SectionHeading from './SectionHeading';

function MetaRow({ heat, time }: { heat: string; time: string }) {
  return (
    <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
      <span className="inline-flex items-center gap-1">
        <i className="ri-fire-line text-primary-500"></i>
        <span className="font-medium text-primary-600">{heat}</span> 热度
      </span>
      <span className="inline-flex items-center gap-1">
        <i className="ri-time-line"></i>
        {time}
      </span>
    </div>
  );
}

export default function Headlines() {
  return (
    <section id="headlines" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="今日聚焦 · HEADLINES"
          title="热点头条"
          accent="事件汇总"
          desc="这个五一，大家都在聊什么？从出行现场到娱乐新瓜，重要热点一次说清。"
        />

        {/* 主编头条：大卡 + 两条并列 */}
        <div className="mt-12 grid gap-5 lg:grid-cols-5">
          <article className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-100 lg:col-span-3">
            <div className="relative h-60 overflow-hidden md:h-80">
              <img
                src={featuredNews[0].image}
                alt={featuredNews[0].title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                {featuredNews[0].tag}
              </span>
              <span className="absolute right-4 top-4 rounded-full bg-background-950/40 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
                {featuredNews[0].category}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-xl leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-2xl">
                {featuredNews[0].title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                {featuredNews[0].summary}
              </p>
              <MetaRow heat={featuredNews[0].heat} time={featuredNews[0].time} />
            </div>
          </article>

          <div className="flex flex-col gap-5 lg:col-span-2">
            {featuredNews.slice(1).map((item) => (
              <article
                key={item.id}
                className="group flex cursor-pointer flex-1 gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-100 p-3 transition-colors hover:bg-background-100"
              >
                <div className="relative h-28 w-28 shrink-0 overflow-hidden rounded-xl md:h-36 md:w-40">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col py-1">
                  <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
                    <i className="ri-price-tag-3-line"></i>
                    {item.tag}
                  </span>
                  <h3 className="mt-2 line-clamp-2 font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-1 hidden text-xs leading-relaxed text-foreground-500 sm:line-clamp-2">
                    {item.summary}
                  </p>
                  <MetaRow heat={item.heat} time={item.time} />
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* 更多实时热点 */}
        <h3 className="mt-14 flex items-center gap-3 font-heading text-2xl text-foreground-900 md:text-3xl">
          更多实时热点
          <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-sm font-sans font-medium text-secondary-700">
            <i className="ri-flashlight-line"></i>
            持续盘点中
          </span>
        </h3>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {newsList.map((item) => (
            <article
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors hover:border-background-300"
            >
              <div className="relative h-44 overflow-hidden md:h-52">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 flex items-center gap-2 bg-gradient-to-t from-background-950/60 to-transparent px-4 pb-3 pt-8">
                  <span className="rounded-full bg-background-50 px-2.5 py-0.5 text-xs font-medium text-primary-600">
                    {item.category}
                  </span>
                  <span className="text-xs text-background-50">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h4 className="line-clamp-2 font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500 md:text-sm">
                  {item.summary}
                </p>
                <MetaRow heat={item.heat} time={item.time} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}